import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const STATUS_NAMES = {
  PENDING: 'Pendente',
  CONFIRMED: 'Confirmado',
  PENDING_SAMSUNG: 'Aguardando Samsung',
  AWAITING_DELIVERY: 'Aguardando Entrega',
  IN_FULFILLMENT: 'Em Atendimento',
  PARTIALLY_FULFILLED: 'Parcialmente Atendido',
  FULFILLED: 'Atendido',
  PARTIALLY_INVOICED: 'Parcialmente Faturado',
  INVOICED: 'Faturado',
  COMPLETED: 'Concluído',
  CANCELED: 'Cancelado',
};

export async function exportReportToExcel(reportData) {
  const workbook = new ExcelJS.Workbook();

  workbook.creator = 'Gaia Samsung PTS';
  workbook.created = new Date();

  const summarySheet = workbook.addWorksheet('Resumo', {
    views: [{ state: 'frozen', xSplit: 0, ySplit: 3 }],
  });
  summarySheet.mergeCells('A1:B1');
  const titleCell = summarySheet.getCell('A1');
  titleCell.value = 'RELATÓRIO DE PEDIDOS CONTIGO';
  titleCell.font = { size: 16, bold: true };
  titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

  summarySheet.mergeCells('A2:B2');
  const periodCell = summarySheet.getCell('A2');
  periodCell.value = `Gerado em: ${new Date().toLocaleString('pt-BR')}`;
  periodCell.alignment = { horizontal: 'center' };

  summarySheet.addRow([]);
  summarySheet.addRow(['INDICADORES GERAIS']);
  summarySheet.getCell('A4').font = { bold: true, size: 12 };

  summarySheet.addRow(['Total de Pedidos', reportData.summary.total_orders]);
  summarySheet.addRow(['Total de Itens', reportData.summary.total_items]);

  const valorTotalRow = summarySheet.addRow(['Valor Total', reportData.summary.total_value]);
  valorTotalRow.getCell(2).numFmt = 'R$ #,##0.00';

  const custoTotalRow = summarySheet.addRow(['Custo Total', reportData.summary.total_cost]);
  custoTotalRow.getCell(2).numFmt = 'R$ #,##0.00';

  const lucroTotal = reportData.summary.total_value - reportData.summary.total_cost;
  const lucroTotalRow = summarySheet.addRow(['Lucro Total', lucroTotal]);
  lucroTotalRow.getCell(2).numFmt = 'R$ #,##0.00';

  const marginPercent =
    reportData.summary.total_value > 0
      ? ((reportData.summary.total_value - reportData.summary.total_cost) /
          reportData.summary.total_value) *
        100
      : 0;
  const margemRow = summarySheet.addRow(['Margem', marginPercent / 100]);
  margemRow.getCell(2).numFmt = '0.00%';

  summarySheet.addRow([]);
  summarySheet.addRow(['PEDIDOS POR STATUS']);
  summarySheet.getCell('A11').font = { bold: true, size: 12 };
  summarySheet.addRow(['Status', 'Quantidade', 'Valor Total']);

  const statusHeaderRow = summarySheet.getRow(12);
  statusHeaderRow.font = { bold: true };
  statusHeaderRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE0E0E0' },
  };

  let rowIndex = 13;
  Object.entries(reportData.summary.by_status).forEach(([status, data]) => {
    summarySheet.addRow([STATUS_NAMES[status] || status, data.count, data.value]);
    summarySheet.getCell(`C${rowIndex}`).numFmt = 'R$ #,##0.00';
    rowIndex++;
  });

  summarySheet.getColumn(1).width = 30;
  summarySheet.getColumn(2).width = 20;

  const detailedSheet = workbook.addWorksheet('Pedidos Detalhados');

  const detailedHeaders = [
    'Nº Pedido',
    'Cliente',
    'CPF/CNPJ',
    'Status',
    'Data Criação',
    'Q&N',
    'Pedido Samsung',
    'Total Itens',
    'Qtd Total',
    'Qtd Atendida',
    'Qtd Faturada',
    '% Atendimento',
    '% Faturamento',
    'Valor Total',
    'Custo Total',
    'Lucro',
    'Margem %',
  ];

  detailedSheet.addRow(detailedHeaders);

  const detailedHeaderRow = detailedSheet.getRow(1);
  detailedHeaderRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  detailedHeaderRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF1976D2' },
  };
  detailedHeaderRow.height = 25;
  detailedHeaderRow.alignment = { vertical: 'middle', horizontal: 'center' };

  reportData.detailed.forEach((order) => {
    detailedSheet.addRow([
      order.order_number,
      order.customer_name,
      order.customer_cgc,
      STATUS_NAMES[order.status] || order.status,
      new Date(order.created_at),
      order.qqn_number || '-',
      order.samsung_order_number || '-',
      order.total_items,
      order.total_quantity,
      order.total_fulfilled,
      order.total_invoiced,
      order.fulfillment_progress / 100,
      order.invoicing_progress / 100,
      order.total_value,
      order.total_cost,
      order.profit,
      order.margin / 100,
    ]);
  });

  detailedSheet.getColumn(5).numFmt = 'dd/mm/yyyy hh:mm';
  detailedSheet.getColumn(12).numFmt = '0.00%';
  detailedSheet.getColumn(13).numFmt = '0.00%';
  detailedSheet.getColumn(14).numFmt = 'R$ #,##0.00';
  detailedSheet.getColumn(15).numFmt = 'R$ #,##0.00';
  detailedSheet.getColumn(16).numFmt = 'R$ #,##0.00';
  detailedSheet.getColumn(17).numFmt = '0.00%';

  detailedSheet.getColumn(1).width = 20;
  detailedSheet.getColumn(2).width = 30;
  detailedSheet.getColumn(3).width = 18;
  detailedSheet.getColumn(4).width = 20;
  detailedSheet.getColumn(5).width = 18;
  detailedSheet.getColumn(6).width = 15;
  detailedSheet.getColumn(7).width = 18;
  detailedSheet.getColumn(8).width = 12;
  detailedSheet.getColumn(9).width = 12;
  detailedSheet.getColumn(10).width = 12;
  detailedSheet.getColumn(11).width = 12;
  detailedSheet.getColumn(12).width = 15;
  detailedSheet.getColumn(13).width = 15;
  detailedSheet.getColumn(14).width = 15;
  detailedSheet.getColumn(15).width = 15;
  detailedSheet.getColumn(16).width = 15;
  detailedSheet.getColumn(17).width = 12;

  detailedSheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];

  const itemsSheet = workbook.addWorksheet('Itens dos Pedidos');

  const itemsHeaders = [
    'Nº Pedido',
    'Cliente',
    'Part Number',
    'PN Anterior',
    'Descrição',
    'Qtd Pedida',
    'Qtd Atendida',
    'Qtd Faturada',
    'Custo Un.',
    'Venda Un.',
    'Valor Total',
    'Custo Total',
    'Lucro',
  ];

  itemsSheet.addRow(itemsHeaders);

  const itemsHeaderRow = itemsSheet.getRow(1);
  itemsHeaderRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  itemsHeaderRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF7B1FA2' },
  };
  itemsHeaderRow.height = 25;
  itemsHeaderRow.alignment = { vertical: 'middle', horizontal: 'center' };

  reportData.detailed.forEach((order) => {
    order.items.forEach((item) => {
      itemsSheet.addRow([
        order.order_number,
        order.customer_name,
        item.part_number,
        item.previous_part_number,
        item.description,
        item.quantity,
        item.quantity_fulfilled,
        item.quantity_invoiced,
        item.cost_price,
        item.sell_price,
        item.total_value,
        item.total_cost,
        item.total_value - item.total_cost,
      ]);
    });
  });

  itemsSheet.getColumn(8).numFmt = 'R$ #,##0.00';
  itemsSheet.getColumn(9).numFmt = 'R$ #,##0.00';
  itemsSheet.getColumn(10).numFmt = 'R$ #,##0.00';
  itemsSheet.getColumn(11).numFmt = 'R$ #,##0.00';
  itemsSheet.getColumn(12).numFmt = 'R$ #,##0.00';

  itemsSheet.getColumn(1).width = 20;
  itemsSheet.getColumn(2).width = 30;
  itemsSheet.getColumn(3).width = 20;
  itemsSheet.getColumn(4).width = 20;
  itemsSheet.getColumn(5).width = 40;
  itemsSheet.getColumn(6).width = 12;
  itemsSheet.getColumn(7).width = 12;
  itemsSheet.getColumn(8).width = 15;
  itemsSheet.getColumn(9).width = 15;
  itemsSheet.getColumn(10).width = 15;
  itemsSheet.getColumn(11).width = 15;
  itemsSheet.getColumn(12).width = 15;
  itemsSheet.getColumn(13).width = 15;

  itemsSheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];

  const invoicesSheet = workbook.addWorksheet('Notas Fiscais');

  const invoicesHeaders = [
    'Nº NF',
    'Nº Pedido',
    'Cliente',
    'CPF/CNPJ',
    'Status',
    'Data Emissão',
    'Data Cancelamento',
    'Chave NFe',
    'Valor Total',
  ];

  invoicesSheet.addRow(invoicesHeaders);

  const invoicesHeaderRow = invoicesSheet.getRow(1);
  invoicesHeaderRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  invoicesHeaderRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF2E7D32' },
  };
  invoicesHeaderRow.height = 25;
  invoicesHeaderRow.alignment = { vertical: 'middle', horizontal: 'center' };

  reportData.invoices.forEach((invoice) => {
    invoicesSheet.addRow([
      invoice.invoice_number,
      invoice.order_number,
      invoice.customer_name,
      invoice.customer_cgc,
      invoice.status === 'AUTHORIZED'
        ? 'Autorizada'
        : invoice.status === 'CANCELLED'
        ? 'Cancelada'
        : invoice.status === 'ERROR'
        ? 'Erro'
        : 'Pendente',
      new Date(invoice.created_at),
      invoice.cancelled_at ? new Date(invoice.cancelled_at) : '-',
      invoice.nfe_key || '-',
      invoice.total_value,
    ]);
  });

  invoicesSheet.getColumn(6).numFmt = 'dd/mm/yyyy hh:mm';
  invoicesSheet.getColumn(7).numFmt = 'dd/mm/yyyy hh:mm';
  invoicesSheet.getColumn(9).numFmt = 'R$ #,##0.00';

  invoicesSheet.getColumn(1).width = 25;
  invoicesSheet.getColumn(2).width = 20;
  invoicesSheet.getColumn(3).width = 30;
  invoicesSheet.getColumn(4).width = 18;
  invoicesSheet.getColumn(5).width = 15;
  invoicesSheet.getColumn(6).width = 18;
  invoicesSheet.getColumn(7).width = 18;
  invoicesSheet.getColumn(8).width = 50;
  invoicesSheet.getColumn(9).width = 15;

  invoicesSheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];

  const invoiceItemsSheet = workbook.addWorksheet('Itens das NFs');

  const invoiceItemsHeaders = [
    'Nº NF',
    'Nº Pedido',
    'Part Number',
    'Descrição',
    'Quantidade',
    'Preço Un.',
    'Total',
  ];

  invoiceItemsSheet.addRow(invoiceItemsHeaders);

  const invoiceItemsHeaderRow = invoiceItemsSheet.getRow(1);
  invoiceItemsHeaderRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  invoiceItemsHeaderRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF00897B' },
  };
  invoiceItemsHeaderRow.height = 25;
  invoiceItemsHeaderRow.alignment = { vertical: 'middle', horizontal: 'center' };

  reportData.invoices.forEach((invoice) => {
    invoice.items.forEach((item) => {
      invoiceItemsSheet.addRow([
        invoice.invoice_number,
        invoice.order_number,
        item.part_number,
        item.description,
        item.quantity,
        item.unit_price,
        item.total_price,
      ]);
    });
  });

  invoiceItemsSheet.getColumn(6).numFmt = 'R$ #,##0.00';
  invoiceItemsSheet.getColumn(7).numFmt = 'R$ #,##0.00';

  invoiceItemsSheet.getColumn(1).width = 25;
  invoiceItemsSheet.getColumn(2).width = 20;
  invoiceItemsSheet.getColumn(3).width = 20;
  invoiceItemsSheet.getColumn(4).width = 40;
  invoiceItemsSheet.getColumn(5).width = 12;
  invoiceItemsSheet.getColumn(6).width = 15;
  invoiceItemsSheet.getColumn(7).width = 15;

  invoiceItemsSheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];

  // Expedições
  const shipmentsSheet = workbook.addWorksheet('Expedições');

  const shipmentsHeaders = [
    'Número',
    'Método',
    'Rastreio/Transportadora',
    'Volumes',
    'Peso Total (kg)',
    'Status',
    'Data Criação',
    'Criado Por',
    'Observações',
    'Motivo Cancelamento',
    'Data Cancelamento',
    'Cancelado Por',
  ];

  shipmentsSheet.addRow(shipmentsHeaders);

  const shipmentsHeaderRow = shipmentsSheet.getRow(1);
  shipmentsHeaderRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  shipmentsHeaderRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFEF6C00' },
  };
  shipmentsHeaderRow.height = 25;
  shipmentsHeaderRow.alignment = { vertical: 'middle', horizontal: 'center' };

  (reportData.shipments || []).forEach((shipment) => {
    shipmentsSheet.addRow([
      shipment.shipment_number,
      shipment.shipping_method === 'CORREIOS'
        ? 'Correios'
        : shipment.shipping_method === 'RETIRADA'
        ? 'Retirada'
        : shipment.shipping_method === 'TRANSPORTADORA'
        ? 'Transportadora'
        : shipment.shipping_method,
      shipment.shipping_method === 'CORREIOS'
        ? shipment.tracking_code || '-'
        : shipment.carrier_name || '-',
      shipment.total_volumes,
      shipment.total_weight || 0,
      shipment.status === 'ACTIVE' ? 'Ativa' : 'Cancelada',
      new Date(shipment.created_at),
      shipment.created_by_name || '-',
      shipment.notes || '-',
      shipment.cancellation_reason || '-',
      shipment.cancelled_at ? new Date(shipment.cancelled_at) : '-',
      shipment.cancelled_by_name || '-',
    ]);
  });

  shipmentsSheet.getColumn(5).numFmt = '#,##0.00';
  shipmentsSheet.getColumn(7).numFmt = 'dd/mm/yyyy hh:mm';
  shipmentsSheet.getColumn(11).numFmt = 'dd/mm/yyyy hh:mm';

  shipmentsSheet.getColumn(1).width = 20;
  shipmentsSheet.getColumn(2).width = 18;
  shipmentsSheet.getColumn(3).width = 30;
  shipmentsSheet.getColumn(4).width = 10;
  shipmentsSheet.getColumn(5).width = 15;
  shipmentsSheet.getColumn(6).width = 12;
  shipmentsSheet.getColumn(7).width = 18;
  shipmentsSheet.getColumn(8).width = 25;
  shipmentsSheet.getColumn(9).width = 40;
  shipmentsSheet.getColumn(10).width = 40;
  shipmentsSheet.getColumn(11).width = 18;
  shipmentsSheet.getColumn(12).width = 25;

  shipmentsSheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];

  // Itens das Expedições
  const shipmentItemsSheet = workbook.addWorksheet('Itens das Expedições');

  const shipmentItemsHeaders = [
    'Nº Expedição',
    'Nº NF',
    'Nº Pedido',
    'Cliente',
    'Volumes',
    'Peso (kg)',
    'Dimensões',
    'Observações',
  ];

  shipmentItemsSheet.addRow(shipmentItemsHeaders);

  const shipmentItemsHeaderRow = shipmentItemsSheet.getRow(1);
  shipmentItemsHeaderRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  shipmentItemsHeaderRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFFF6F00' },
  };
  shipmentItemsHeaderRow.height = 25;
  shipmentItemsHeaderRow.alignment = { vertical: 'middle', horizontal: 'center' };

  (reportData.shipments || []).forEach((shipment) => {
    (shipment.items || []).forEach((item) => {
      shipmentItemsSheet.addRow([
        shipment.shipment_number,
        item.invoice_number,
        item.order_number,
        item.customer_name,
        item.volumes,
        item.weight || 0,
        item.dimensions || '-',
        item.notes || '-',
      ]);
    });
  });

  shipmentItemsSheet.getColumn(6).numFmt = '#,##0.00';

  shipmentItemsSheet.getColumn(1).width = 20;
  shipmentItemsSheet.getColumn(2).width = 25;
  shipmentItemsSheet.getColumn(3).width = 20;
  shipmentItemsSheet.getColumn(4).width = 30;
  shipmentItemsSheet.getColumn(5).width = 10;
  shipmentItemsSheet.getColumn(6).width = 12;
  shipmentItemsSheet.getColumn(7).width = 25;
  shipmentItemsSheet.getColumn(8).width = 40;

  shipmentItemsSheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const fileName = `relatorio-pedidos-${new Date().toISOString().split('T')[0]}.xlsx`;
  saveAs(blob, fileName);
}
